import { useQueryLegalEntity } from '@webapp/platform/legal-entities/features/view-legal-entity-details'

export const useLegalEntityDetailsPage = ({ uuid }: { uuid: string }) => {
  const { entity } = useQueryLegalEntity(uuid)

  return {
    data: {
      entity,
    },
  }
}
